import { render } from "./SelectCommessa.vue?vue&type=template&id=5efca6c8"
import script from "./SelectCommessa.vue?vue&type=script&lang=js"
export * from "./SelectCommessa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__